import React from "react";
import PhysicianProfileSidebar from "../Components/PhysicianProfileSidebar";
import Header from "../Components/Header";
import PageHeader from "../Components/PageHeader";
import Footer from "../Components/Footer";
import { Link } from "react-router-dom";
import DaySelector from "../Components/DaySelector";
import { edit } from "../Constant/Index";

function Addphysicianavail() {
  return (
    <>
      <Header />
      <PageHeader pagename="Physician Profile" />
      <section className="main-sidebar user-profile">
        <div className="container">
          <div className="row">
            <div className="col-lg-4">
              <PhysicianProfileSidebar />
            </div>
            <div className="col-lg-8">
              <div className="main-profile-content radius-20 p-4">
                <div className="row">
                  <div className="col-md-6">
                    <div className="main-heading d-flex align-items-center gap-3 mb-3">
                      <div className="edit-btn back">
                        <div className="nav-anchor"></div>
                      </div>
                      <h5 className="main-heading level-6 main-heading-font dark-color mb-0 wow animate__animated animate__zoomIn animate__delay-1s">
                      Add Your Availability
                      </h5>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div
                      style={{
                        float: "right",
                      }}
                      className="main-heading d-flex align-items-center gap-3 mb-3"
                    >
                      <div className="edit-btn back">
                        <Link to="/physician-time">
                          <div className="nav-anchor">
                            <img src={edit} alt="Edit" className="img-fluid" />
                          </div>
                        </Link>
                      </div>
                      <h5 className="main-heading level-6 main-heading-font dark-color mb-0 wow animate__animated animate__zoomIn animate__delay-1s">
                        Back
                      </h5>
                    </div>
                  </div>
                </div>
                <DaySelector />
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
}

export default Addphysicianavail;
